export function qr_patters_polygon(qrWidth, qrCells, unit = "px") {
  const cellWidth = qrWidth / qrCells;
  const u = unit;

  function pattern_square(x0, y0, s) {
    const x1 = x0 + s;
    const y1 = y0 + s;
    return `${x0}${u} ${y0}${u}, ${x1}${u} ${y0}${u}, ${x1}${u} ${y1}${u}, ${x0}${u} ${y1}${u}, ${x0}${u} ${y0}${u}`;
  }

  function pattern(x0, y0) {
    return `${pattern_square(x0, y0, 7 * cellWidth)},
              ${pattern_square(x0 + cellWidth, y0 + cellWidth, 5 * cellWidth)},
              ${pattern_square(x0 + 2 * cellWidth, y0 + 2 * cellWidth, 3 * cellWidth)}, ${x0}${u} ${y0}${u}`;
  }

  return `polygon(evenodd,
      ${pattern(0, (qrCells - 7) * cellWidth)},
      ${pattern(0, 0)},
      ${pattern((qrCells - 7) * cellWidth, 0)},
      0${u} 0${u}
    )`;
}

export function square_mask_polygon(x0, y0, width, height, unit = "px") {
  const u = unit;
  return `polygon(
    0% 0%,
    0% 100%,
    ${x0}${u} 100%,
    ${x0}${u} ${y0}${u},
    ${x0 + width}${u} ${y0}${u},
    ${x0 + width}${u} ${y0 + height}${u},
    ${x0}${u} ${y0 + height}${u},
    ${x0}${u} 100%,
    100% 100%,
    100% 0%
  )`;
}

export function square_mask_polygon2(size) {
  return `polygon(
    0% 0%,
    0% 100%,
    calc(50% - ${size}px) 100%,
    calc(50% - ${size}px) calc(50% - ${size}px),
    calc(50% + ${size}px) calc(50% - ${size}px),
    calc(50% + ${size}px) calc(50% + ${size}px),
    calc(50% - ${size}px) calc(50% + ${size}px),
    calc(50% - ${size}px) 100%,
    100% 100%,
    100% 0%
  )`;
}

export function square_mask_polygon3(size) {
  return `polygon(
    0% 0%,
    0% 100%,
    calc(50% - ${size}px) 100%,
    calc(50% - ${size}px) calc(50% - ${size}px),
    calc(50% + ${size}px) calc(50% - ${size}px),
    calc(50% + ${size}px) calc(50% + ${size * 3}px),
    calc(50% - ${size}px) calc(50% + ${size * 3}px),
    calc(50% - ${size}px) 100%,
    100% 100%,
    100% 0%
  )`;
}
